import { WSQueryConfig } from "@ws-react-query";
import {
  listRequirements,
  RequirementsListQuery
} from "../../../services/requirements/listRequirements";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";
import { QUERY_REQUIREMENTS_FULL_LIST_SIZE } from "../keys";

export const useQueryRequirementsListSize = (
  params?: RequirementsListQuery,
  config?: WSQueryConfig<number, WSServiceError>
) =>
  useWSQuery(
    [QUERY_REQUIREMENTS_FULL_LIST_SIZE, params],
    async () => {
      const { summary } = await listRequirements({
        ...params,
        page: { size: 1, number: 1 }
      });
      return summary.listSize;
    },
    config
  );
